import type { SVGProps } from "react";
const SenecPictogramClick = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            d="M20 9C20 8.44772 19.5523 8 19 8C18.4477 8 18 8.44772 18 9V13C18 13.5523 18.4477 14 19 14C19.5523 14 20 13.5523 20 13V9Z"
            fill="currentColor"
        />
        <path
            d="M16.2049 16.2049L21.3857 29.1568C21.5908 29.6696 22.1728 29.919 22.6856 29.7139C23.1983 29.5088 23.4478 28.9268 23.2426 28.414L19.7951 19.7951L35.7568 26.1797L31.3872 28.8015L37.5858 35L35 37.5858L28.8015 31.3872L26.1797 35.7568L25.3285 33.6286C25.1234 33.1158 24.5414 32.8664 24.0286 33.0715C23.5158 33.2766 23.2664 33.8586 23.4715 34.3714L25.8203 40.2432L29.1985 34.6128L33.5858 39C34.3668 39.781 35.6332 39.781 36.4142 39L39 36.4142C39.781 35.6332 39.781 34.3668 39 33.5858L34.6128 29.1985L40.2432 25.8203L16.2049 16.2049Z"
            fill="currentColor"
        />
        <path
            d="M26.7784 11.2216C27.1689 11.6121 27.1689 12.2453 26.7784 12.6358L23.95 15.4642C23.5594 15.8548 22.9263 15.8548 22.5358 15.4642C22.1452 15.0737 22.1452 14.4406 22.5358 14.05L25.3642 11.2216C25.7547 10.8311 26.3879 10.8311 26.7784 11.2216Z"
            fill="currentColor"
        />
        <path
            d="M15.4649 23.9498C15.8554 23.5593 15.8554 22.9261 15.4649 22.5356C15.0744 22.145 14.4412 22.145 14.0507 22.5356L11.2223 25.364C10.8318 25.7545 10.8318 26.3877 11.2223 26.7782C11.6128 27.1687 12.246 27.1687 12.6365 26.7782L15.4649 23.9498Z"
            fill="currentColor"
        />
        <path
            d="M10.2216 10.2216C10.6121 9.83108 11.2453 9.83108 11.6358 10.2216L14.4642 13.05C14.8548 13.4406 14.8548 14.0737 14.4642 14.4642C14.0737 14.8548 13.4406 14.8548 13.05 14.4642L10.2216 11.6358C9.83108 11.2453 9.83108 10.6121 10.2216 10.2216Z"
            fill="currentColor"
        />
        <path
            d="M9 18C8.44772 18 8 18.4477 8 19C8 19.5523 8.44772 20 9 20H13C13.5523 20 14 19.5523 14 19C14 18.4477 13.5523 18 13 18H9Z"
            fill="currentColor"
        />
    </svg>
);
export default SenecPictogramClick;
